import posthog from "posthog-js";

if (process.env.NEXT_PUBLIC_POSTHOG_ENABLED === "true") {
    // biome-ignore lint/style/noNonNullAssertion: TRUST THE DEV
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
        api_host: "/sonic", // https://posthog.com/docs/advanced/proxy/nextjs
        ui_host: "https://eu.i.posthog.com",
        session_recording: {
            maskAllInputs: false, // show inputs content in session recordings
        },
    });
}
